var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-538b841a-b798-4d82-aa2d-4afe49d9f122",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 50.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.65,11.97c.59,3.48-2.67,7.07-6.19,6.82s-5.33-3.5-5.16-7.63c.13-3.4,2.93-6.3,5.75-8.21s6.89-1.98,9.94-.47,4.75,4.66,3.61,8.02c-3.83,11.29-7.65,22.59-11.48,33.88-.53,1.55.36,3.44,1.89,4.03s3.51-.19,4.11-1.72c5.87-15.08,6.35-18.05,12.7-34.38",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.71,45.1c-.61,1.69.33,2.68,1.52,3.26s2.68.06,3.62-.88,1.44-2.21,1.92-3.45c4.24-10.94,7.74-21.39,11.98-32.33.75-1.74,2.42-3.09,4.3-3.32s3.89.76,4.74,2.45.41,3.98-1.11,5.11-3.94.88-5.08-.64",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m41.15,30.18c-.42-1.32-2.3-1.62-3.49-.91s-1.83,2.04-2.41,3.29c-1.68,3.63-3.8,8.53-5.34,12.22-.29.7-.58,1.43-.61,2.19s.78,1.81,1.43,2.2c.76.46,1.78.21,2.47-.34s1.11-1.36,1.52-2.15c2.06-3.95,4.06-9.41,6.13-13.36.31-.6.63-1.22.65-1.89s-.33-1.41-.35-1.25Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.51,29.57c-1-1.09-3.02-.92-3.83.31s-.16,3.15,1.23,3.64c1.18.41,2.46-.12,3.6-.65,1.57-.73,3.13-1.45,4.7-2.18.43-.2.91-.46,1-.93.11-.63-.75-1.12-1.3-.8s-.63,1.17-.25,1.68,1.08.7,1.72.62,1.2-.42,1.73-.78,1.02-.77,1.6-1.05c-3.5,5.24-6.91,10.58-9.54,16.31-.48,1.05-1.08,2.58,0,3.32.64.45,2.9.87,5.41-2.31.25-.32,15.08-22.94,22.24-34.64.64-1.05,1.28-2.4.61-3.42-.66-1-2.25-.94-3.19-.19s-1.39,1.94-1.79,3.07c-4.58,12.74-9.16,25.48-13.73,38.21,1.33-6.62,4.43-12.86,8.9-17.92,1.09-1.24,2.9-2.48,4.23-1.51,1.18.86.85,2.73.11,3.99-1.3,2.23-3.49,3.91-5.98,4.6-.67.19-1.47.27-2-.18s-.32-1.58.38-1.54c-.45,1.98-.9,4.01-.65,6.03s1.33,4.06,3.18,4.89c1.79.8,3.95.33,5.6-.73s2.9-2.63,4.12-4.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork02);
export default __webpack_public_path__ + "static/media/Work-02.8eac2827908a43129a9a3f6e70b8b823.svg";
export { ForwardRef as ReactComponent };